import { addActionBarItem } from "@vendure/admin-ui/core";

export default [
  addActionBarItem({
    id: "shippin-method-tutorial-english",
    locationId: "shipping-method-list",
    label: "Tutorial (English 🇬🇧)",
    icon: "play",
    buttonColor: "warning",
    onClick: () => {
      window.open(
        "https://www.youtube.com/watch?v=GwlJAEVuq9o&list=PLF8K4z615VxeBBBxj2Klzyn24Tns_Yn1R&index=8",
        "_blank",
      );
    },
  }),
  addActionBarItem({
    id: "shippin-method-tutorial-spanish",
    locationId: "shipping-method-list",
    label: "Tutorial (Spanish 🇪🇸)",
    icon: "play",
    buttonColor: "warning",
    onClick: () => {
      window.open(
        "https://www.youtube.com/watch?v=Dt-map0po1g&list=PLF8K4z615VxcgoUVzdF2udQck37tETSau&index=8",
        "_blank",
      );
    },
  }),
];
